import React from "react";

/**
 * The React context object consumers may use to access the context of the
 * portal.
 */
export var PortalContext = /*#__PURE__*/React.createContext({});
PortalContext.displayName = "PortalContext";